<template>
      <div fluid fill-height>
        <v-expand-x-transition>
          <landing-toolbar />
        </v-expand-x-transition>
        <v-container style="min-width:100% !important">
          <Reports />
        </v-container>
      </div>
</template>
    
    <script>
   import Reports from '../../components/Reportes/Reports.vue';
    import LandingToolbar from '../../components/LandingToolbar/LandingToolbar.vue'
    export default {
      components: { Reports, LandingToolbar },
    };
    </script>
    